// extracted by mini-css-extract-plugin
export default {"column":"infoHistory_column__0BEKo","img":"infoHistory_img__x1I9K","description":"infoHistory_description__EsFqS"};